import React from 'react';
import miaLogo from './logo-mia.svg';

// Mia is a colored brand badge (not a monochrome vector icon), so it is
// rendered as an <img>. Sized in `em` relative to the other nav icons, which
// receive the `text-30` (30px) class through the menu's cloneElement call.
// The badge reads smaller than the line icons at the same box size, so it is
// scaled up to stay legible next to them.
export const MiaIcon = React.forwardRef(({ style, ...props }, ref) => (
  <img
    ref={ref}
    src={miaLogo}
    alt="Mia"
    style={{ width: '1.6em', height: '1.6em', objectFit: 'contain', ...style }}
    {...props}
  />
));

export default React.memo(MiaIcon);
